var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full_load"},[_c('div',{staticClass:"row align-items-center justify-content-center h-100"},[_c('scale-loader',{attrs:{"loading":_vm.loading,"color":_vm.color,"height":_vm.height,"width":_vm.width}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }